import {
  Avatar,
  Button,
  List,
  ListItem,
  Stack,
  Typography,
} from '@mui/material';
import { MedicalReferralItem } from 'API/Home/userUpdates';
import { requestFile } from 'API/medicalReferrals';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useLoader } from 'Hooks/useLoader';
import { AccordionArrowBlue, PurpleDownloadIcon } from 'Images';
import { downloadFile } from 'Utils';
import { useState } from 'react';

interface IReferralListItem {
  items: MedicalReferralItem[];
}
export const MedicalReferralListMobile = ({ items }: IReferralListItem) => {
  const [isOpen, setIsOpen] = useState(false);
  const { isLoading, loader, setIsLoading } = useLoader(
    'scale(0.25)',
    undefined,
    undefined,
    false
  );

  const dictionary = useDictionary(Dictionary, DICTIONARY.Home).userUpdates;
  const isDesktop = useIsDesktop();

  const download = async (
    e: React.MouseEvent<HTMLElement, MouseEvent>,
    id: string
  ) => {
    setIsLoading(true);
    e.stopPropagation();
    const file = await requestFile(parseInt(id));
    setIsLoading(false);
    if (file && file.fileContentBase64) {
      downloadFile(
        file.fileContentBase64,
        'pdf',
        file.documentName || 'New Document'
      );
    }
  };

  return !isDesktop ? (
    <Stack>
      {isOpen && (
        <List sx={{ overflowY: 'auto', maxHeight: '285px' }}>
          {items.map((item: MedicalReferralItem, index: number) => (
            <ListItem
              sx={{
                p: 0,
              }}
            >
              <Stack
                sx={{
                  flexDirection: 'row',
                  borderBottom: '1px solid',
                  borderColor: 'primary.shade_100',
                  p: '7px 0',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Typography variant='body6' sx={{ fontWeight: 600 }}>
                  {item.Subject}{' '}
                </Typography>
                <Button
                  onClick={(e) => download(e, item.Id)}
                  startIcon={
                    <Avatar
                      src={PurpleDownloadIcon}
                      alt=''
                      sx={{ width: '22px', height: '22px' }}
                    />
                  }
                  sx={{
                    fontSize: '16px',
                    color: 'primary.secondary',
                    fontWeight: 600,
                    pr: '20px',
                  }}
                >
                  {Dictionary[DICTIONARY.Home].userUpdates.toDownload}
                </Button>
              </Stack>
            </ListItem>
          ))}
        </List>
      )}
      <Button
        sx={{
          fontSize: '16px',
          color: 'primary.main',
          fontWeight: 600,
          alignSelf: isOpen ? 'center' : 'start',
          p: 0,
          mb: 2,
        }}
        onClick={() => setIsOpen(!isOpen)}
        endIcon={
          <Avatar
            src={AccordionArrowBlue}
            sx={{
              width: '24px',
              height: '24px',
              rotate: isOpen ? '180deg' : 0,
            }}
          />
        }
      >
        {isOpen ? dictionary.closeList : dictionary.downloadMedicalReferrals}
      </Button>
    </Stack>
  ) : (
    <></>
  );
};
